<div *ngIf="loading" class="overlay">
    <mat-spinner diameter="70"></mat-spinner>
</div>